//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from '../utils/create';
import { props } from './props';
import { Decimal } from 'decimal.js';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "input-number",
    class: {
      'is-disabled': _vm.disabled
    }
  }, [_c('button', {
    staticClass: "input-number__btn-decrease",
    on: {
      "click": _vm.handleDecrease
    }
  }, [_vm._t("icon-decrease", function () {
    return [_vm._v(" - ")];
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.selfValue,
      expression: "selfValue",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input-number__input",
    class: {
      'is-disabled': _vm.disabled || _vm.disabledInput
    },
    attrs: {
      "type": "text",
      "disabled": _vm.disabled || _vm.disabledInput
    },
    domProps: {
      "value": _vm.selfValue
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.selfValue = $event.target.value.trim();
      }, _vm.handleChange],
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "input-number__btn-increase",
    on: {
      "click": _vm.handleIncrease
    }
  }, [_vm._t("icon-increase", function () {
    return [_vm._v(" + ")];
  })], 2)]);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-38529653',
  render,
  name: 'CbInputNumber',
  props,
  watch: {
    value: {
      handler(newValue) {
        if (typeof newValue === 'number' && !Number.isNaN(newValue) && this.lastValidValue !== newValue) {
          this.selfValue = newValue;
          this.lastValidValue = newValue;
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      selfValue: 0,
      lastValidValue: 0,
      validRegExp: /^-?[0-9]+(\.[0-9]+)?$/
    };
  },
  methods: {
    handleDecrease() {
      if (this.disabled) {
        return;
      }
      this.predicateValue();
      if (this.lastValidValue === '') {
        return;
      }
      var selfValue = new Decimal(this.selfValue);
      this.selfValue = Number.parseFloat(selfValue.minus(this.step).valueOf());
      this.predicateMin();
      this.lastValidValue = this.selfValue;
      this.$emit('decrease');
      this.triggerValue();
    },
    handleChange() {
      // 处理正在输入小数的问题，负号的问题
      if (this.selfValue === '' || this.selfValue === '-' || /^-?[0-9]+\.$/.test(this.selfValue)) {
        this.lastValidValue = this.selfValue;
        return;
      }
      if (this.validRegExp.test(this.selfValue)) {
        this.predicateMax();
        this.predicateMin();
        this.lastValidValue = Number.parseFloat(this.selfValue);
        this.triggerValue();
      } else {
        this.selfValue = this.lastValidValue;
      }
    },
    handleIncrease() {
      if (this.disabled) {
        return;
      }
      this.predicateValue();
      if (this.lastValidValue === '') {
        return;
      }
      // 处理0.1+0.2的边界场景
      var selfValue = new Decimal(this.selfValue);
      this.selfValue = Number.parseFloat(selfValue.add(this.step).valueOf());
      this.predicateMax();
      this.lastValidValue = this.selfValue;
      this.$emit('increase');
      this.triggerValue();
    },
    predicateValue() {
      if (!this.validRegExp.test(this.selfValue)) {
        this.selfValue = this.lastValidValue;
      }
    },
    predicateMin() {
      if (typeof this.min === 'number' && this.selfValue < this.min) {
        this.selfValue = this.min;
      }
    },
    predicateMax() {
      if (typeof this.max === 'number' && this.selfValue > this.max) {
        this.selfValue = this.max;
      }
    },
    triggerValue() {
      this.$emit('change', this.lastValidValue);
      this.$emit('input', this.lastValidValue);
    }
  }
});